import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider, useAuth } from "./lib/auth";
import { MoneyProvider, useMoney } from "./lib/money";
import Layout from "./components/Layout";
import { Loading } from "./components/common";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Workers from "./pages/Workers";
import WorkerDetail from "./pages/WorkerDetail";
import Sites from "./pages/Sites";
import SiteDetail from "./pages/SiteDetail";
import Vehicles from "./pages/Vehicles";
import VehicleDetail from "./pages/VehicleDetail";
import Planning from "./pages/Planning";
import CalendarPage from "./pages/CalendarPage";
import Operations from "./pages/Operations";
import PrintSheet from "./pages/PrintSheet";
import PrintVehicles from "./pages/PrintVehicles";
import Finance from "./pages/Finance";
import PrintQuoteWork from "./pages/PrintQuoteWork";
import Documents from "./pages/Documents";
import Notifications from "./pages/Notifications";
import UsersPage from "./pages/Users";
import SettingsPage from "./pages/Settings";
import Profile from "./pages/Profile";
import MyShifts from "./pages/MyShifts";
import ImportPage from "./pages/ImportPage";

function Protected({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

const A = ["admin"];
const S = ["admin", "responsabile"];
const O = ["operaio"];

function AppRoutes() {
  const { user } = useAuth();
  useMoney();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/stampa-presenze" element={<Protected roles={S}><PrintSheet /></Protected>} />
      <Route path="/stampa-lavorazioni/:id" element={<Protected roles={A}><PrintQuoteWork /></Protected>} />
      <Route path="/stampa-mezzi" element={<Protected roles={A}><PrintVehicles /></Protected>} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="operai" element={<Protected roles={A}><Workers /></Protected>} />
        <Route path="operai/:id" element={<Protected roles={S}><WorkerDetail /></Protected>} />
        <Route path="cantieri" element={<Protected roles={S}><Sites /></Protected>} />
        <Route path="cantieri/:id" element={<Protected roles={S}><SiteDetail /></Protected>} />
        <Route path="mezzi" element={<Protected roles={A}><Vehicles /></Protected>} />
        <Route path="mezzi/:id" element={<Protected roles={S}><VehicleDetail /></Protected>} />
        <Route path="pianificazione" element={<Protected roles={S}><Planning /></Protected>} />
        <Route path="calendario" element={<CalendarPage />} />
        <Route path="operativa" element={<Protected roles={S}><Operations /></Protected>} />
        <Route path="economia" element={<Protected roles={A}><Finance /></Protected>} />
        <Route path="documenti" element={<Documents />} />
        <Route path="notifiche" element={<Notifications />} />
        <Route path="utenti" element={<Protected roles={A}><UsersPage /></Protected>} />
        <Route path="impostazioni" element={<Protected roles={A}><SettingsPage /></Protected>} />
        <Route path="importa" element={<Protected roles={A}><ImportPage /></Protected>} />
        <Route path="profilo" element={<Profile />} />
        <Route path="turni" element={<Protected roles={O}><MyShifts /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <MoneyProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </MoneyProvider>
      <Toaster theme="dark" position="top-right" richColors closeButton />
    </AuthProvider>
  );
}
